import * as React from 'react';
import * as moment from 'moment';

import { GridEventProps } from '../../components/grid/event';

const GridEventView: React.StatelessComponent<GridEventProps> = props => {
    const todayMoment = moment();
    const eventMoment = moment(props.event.eventDate);
    const isEventInPast = eventMoment.isBefore(todayMoment, 'day');

    return (
        <li className="ace-cal-grid-event">
            <article className="ace-cal-grid-event-content">
                <p className="ace-cal-grid-event-time">{eventMoment.format("h:mm a")}</p>
                {!isEventInPast ? (
                    <h5 className="ace-cal-grid-event-name"><a href={props.event.viewDetailCtaUrl}>{props.event.name}</a></h5>
                ) : (
                        <h5 className="ace-cal-grid-event-name past-event">{props.event.name}</h5>
                    )}
                {/* If not sold out */}
                {!isEventInPast && props.event.buyTicketCtaUrl.length > 0 ? (
                    <a className="ace-cal-grid-event-cta arrow-link" href={props.event.buyTicketCtaUrl}>{props.event.buyTicketCtaText}</a>
                ) : ""}
                {/* If sold out */}
                {!isEventInPast && props.event.buyTicketCtaUrl.length === 0 ? (
                    <p className="ace-cal-grid-event-na">{props.event.buyTicketCtaText}</p>
                ) : ""}
                {
                    props.event.optionalMessage && props.event.optionalMessage.length > 0 
                        ? <div className="ace-cal-grid-event-na"><p>{props.event.optionalMessage}</p></div>
                        : ""
                }
                {
                    props.event.buyTicketCtaUrl.length > 0 && props.event.priceText ? <p className="ace-cal-grid-event-na">{props.event.priceText}</p> : null
                }
                {
                    props.event.accessibilityInfo ? props.event.accessibilityInfo.map(a => <img className="ace-cal-grid-event-img" src={a.icon} />) : null
                }

            </article>
        </li>
    );
}

export default GridEventView; 